/**
 * Creates a ProposalDataField with common defaults.
 */
export var makeField = function (tag, subfieldCode, value, fieldIndex, subfieldIndex, indicator1, indicator2) {
    if (indicator1 === void 0) { indicator1 = ' '; }
    if (indicator2 === void 0) { indicator2 = ' '; }
    return ({
        field_tag: tag,
        field_index: fieldIndex,
        indicator1: indicator1,
        indicator2: indicator2,
        subfield_code: subfieldCode,
        subfield_index: subfieldIndex,
        value: value,
    });
};
